import { ComposeCoAuthorData, ComposeCoAuthorSchema } from ".";
import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import "../../utils/YupHelper";
import { DefaultPhoneNumber, PhoneNumberData, PhoneNumberSchemaRequired, ReactSelectOptionSchema } from "../generic";

export interface ComposeAuthorshipData {
    abstractId: number;
    authors: ComposeCoAuthorData[];
    displayProfilePicture: boolean;
    keywords: Array<ReactSelectOption | null>;
    phone: PhoneNumberData;
    studyGroup?: string;
    title: string;
    typeId?: number;
}

export class ComposeAuthorship implements FormValidationModel<ComposeAuthorshipData> {
    public data: ComposeAuthorshipData;
    public rules: yup.Schema<ComposeAuthorshipData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            authors: [],
            displayProfilePicture: true,
            keywords: [],
            phone: DefaultPhoneNumber,
            title: "",
        };
        this.rules = yup.object<ComposeAuthorshipData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            authors: yup.array().of(ComposeCoAuthorSchema).label("Co author(s)"),
            displayProfilePicture: yup.boolean(),
            keywords:  yup.array().of(ReactSelectOptionSchema).nullable(true).required().min(3).max(5).label("Keywords"),
            phone: PhoneNumberSchemaRequired.label("Mobile phone number").required(),
            studyGroup: yup.string().label("Study group").max(4000),
            title: (yup.string().required().label("Title") as any).richtextchar_max(150, "$label may not exceed ${max} characters"),
            typeId: yup.number().required().label("Presentation format").nullable(true).min(1, "invalid $label"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/abstract/ComposeAuthorship.ts